"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsOverflowItemVisible", {
    enumerable: true,
    get: function() {
        return useIsOverflowItemVisible;
    }
});
const _overflowContext = require("./overflowContext");
function useIsOverflowItemVisible(id) {
    return !!(0, _overflowContext.useOverflowContext)((ctx)=>ctx.itemVisibility[id]);
}
